export enum CLASS {
  VISIBLE = 'is-visible',
  INVISIBLE = 'is-invisible'
}
